import { Component} from '@angular/core';

import { fuseAnimations } from '@fuse/animations';

///IDIOMAS
import { lang_configuracion } from '../../../../idiomas/i18n/configuracion/configuracion.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
  selector: 'app-upload-file',
  templateUrl: './uploadfile.component.html',
  styleUrls: ['./uploadfile.component.scss'],
  animations : fuseAnimations
})
export class UploadFileComponent  {

  files: any = [];
  public imagePath;
  imgURL: any;
  public message: string;


  uploadFile(event) {

    var mimeType = event[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      //return;
    }else{
       var reader = new FileReader();
        this.imagePath = event;
        reader.readAsDataURL(event[0]);
        reader.onload = (_event) => {
          this.imgURL = reader.result;
        }
    }

    for (let index = 0; index < event.length; index++) {
      const element = event[index];
      console.log(element);
      console.log(element.value);
      this.files.push(element.name)
    }
  }
  deleteAttachment(index) {
    this.files.splice(index, 1)
  }

  constructor(
      private _fuseTranslationLoaderService: FuseTranslationLoaderService
  )
  {
      //this._fuseTranslationLoaderService.loadTranslations(lang_configuracion);
      lang_configuracion.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
      });
  }




}
